const STORAGE_KEY = 'loto649_generation_logs_v1';
const DAY_IN_MS = 24 * 60 * 60 * 1000;

const getStartOfLocalDay = (date = new Date()) => (
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
);

const getSafeLogs = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const logGeneration = (count = 1) => {
  const safeCount = Number(count);

  if (!Number.isInteger(safeCount) || safeCount < 1) return;

  try {
    const logs = getSafeLogs();
    logs.push({
      timestamp: new Date().toISOString(),
      count: safeCount
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
  } catch (error) {
    console.warn('Nu s-a putut salva jurnalul de generare.', error);
  }
};

export const getGenerationStats = () => {
  const logs = getSafeLogs();
  const startOfToday = getStartOfLocalDay();
  const startOfYesterday = startOfToday - DAY_IN_MS;
  const startOf7Days = startOfToday - 6 * DAY_IN_MS;
  const startOf30Days = startOfToday - 29 * DAY_IN_MS;

  return logs.reduce(
    (stats, item) => {
      const time = new Date(item.timestamp).getTime();
      const count = Number(item.count);

      if (!Number.isFinite(time) || !Number.isInteger(count) || count < 1) {
        return stats;
      }

      stats.lifetime += count;
      stats.totalEvents += 1;

      if (time >= startOfToday) {
        stats.today += count;
      } else if (time >= startOfYesterday) {
        stats.yesterday += count;
      }

      if (time >= startOf7Days) {
        stats.last7Days += count;
      }

      if (time >= startOf30Days) {
        stats.last30Days += count;
      }

      return stats;
    },
    {
      lifetime: 0,
      today: 0,
      yesterday: 0,
      last7Days: 0,
      last30Days: 0,
      totalEvents: 0
    }
  );
};